export const mode = import.meta.env.MODE

export const isProduction = import.meta.env.PROD
export const isDevelopment = import.meta.env.DEV
export const isTest = mode === 'test' || Boolean(import.meta.env.VITEST)
